const SCRIPT_ID = 'bpz-ga-script';
const INLINE_ID = 'bpz-ga-inline';

function removeGaArtifacts() {
  document.getElementById(SCRIPT_ID)?.remove();
  document.getElementById(INLINE_ID)?.remove();
}

export function applyAnalyticsConsent(allowed: boolean) {
  const enabled = process.env.NEXT_PUBLIC_GA_ENABLED === '1';
  const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || '';

  if (!allowed || !enabled || !measurementId) {
    removeGaArtifacts();
    return;
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
  }

  if (!document.getElementById(INLINE_ID)) {
    const inline = document.createElement('script');
    inline.id = INLINE_ID;
    inline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}', { anonymize_ip: true });
    `;
    document.head.appendChild(inline);
  }
}
